import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import { DashboardAction } from 'redux/actions';
import { checkPermissions } from 'hooks';

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};

const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);
    destClone.splice(droppableDestination.index, 0, removed);
    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;
    return result;
};

const grid = 8;
const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,
    background: isDragging ? 'rgb(58 172 214)' : 'rgb(58 172 214)',
    color: '#fff',
    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    padding: grid,
    minHeight: '64px',
    border: '1px dashed #6c757d'
});


const WidgetSelector = (props) => {




    let [items, setItems] = React.useState([]);


    React.useEffect(() => {
        
        let widgetItems = [];
        checkPermissions(props.loginData, 'dashboard_data') && widgetItems.push({ id: `SwisAnalytics`, content: `Swis Analytics` });
        checkPermissions(props.loginData, 'google_analytics') && widgetItems.push({ id: `GoogleAnalytics`, content: `Google Analytics` });
        checkPermissions(props.loginData, 'google_analytics_graph') && widgetItems.push({ id: `GoogleAnalyticsGraph`, content: `Google Analytics Graph` });
        checkPermissions(props.loginData, 'top_searches') && widgetItems.push({ id: `TopSearches`, content: `Top Searches` });
        checkPermissions(props.loginData, 'top_searches') && widgetItems.push({ id: `PopularSearches`, content: `Popular Searches` });
        checkPermissions(props.loginData, 'failed_urls') && widgetItems.push({ id: `FailedUrlGraph`, content: `Failed Urls Graph` });
        checkPermissions(props.loginData, 'users_locations') && widgetItems.push({ id: `MapComp`, content: `Users Location` });
        setItems(widgetItems);
        console.log('props.loginData----------', widgetItems)
    }, [props.loginData]);


    let [state, setState] = React.useState({
        items: items,
        selected: []
    })



    let id2List = {
        droppable: 'items',
        droppable2: 'selected'
    };

    const getList = (id) => {
        return state[id2List[id]];
    }



    React.useEffect(() => {
        let selected = props.widgetSaved
        items = items.filter((item) => ((props.widgetSaved).findIndex((it) => it.id === item.id) < 0) ? true : false)
        setState({
            items: items,
            selected: selected
        })
    }, [props.widgetSaved,items]);

    const onDragEnd = result => {
        const { source, destination } = result;

        // dropped outside the list
        if (!destination) {
            return;
        }

        if (source.droppableId === destination.droppableId) {
            const items = reorder(
                getList(source.droppableId),
                source.index,
                destination.index
            );



            if (source.droppableId === 'droppable2') {
                //state = { selected: items };
                props.saveDashboardWidget({ widget_json: items });
            }

            //setState(state);

        } else {
            const result = move(
                getList(source.droppableId),
                getList(destination.droppableId),
                source,
                destination
            );
            setItems(result.droppable)
            /*setState({
                items: result.droppable,
                selected: result.droppable2
            });*/
            props.saveDashboardWidget({ widget_json: result.droppable2 });
        }

    };


    return (
        <div>
            <DragDropContext onDragEnd={onDragEnd}>
                <Row>
                    <Col md={6}>
                        <h6>Widgets List</h6>
                        <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                                <div
                                    ref={provided.innerRef}
                                    style={getListStyle(snapshot.isDraggingOver)}>
                                    {(state.items && state.items.length > 0) && state.items.map((item, index) => (
                                        <Draggable
                                            key={item.id}
                                            draggableId={item.id}
                                            index={index}>
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style
                                                    )}>
                                                    {item.content}
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </Col>
                    <Col md={6}>
                        <h6>Selected Widgets</h6>
                        <Droppable droppableId="droppable2">
                            {(provided, snapshot) => (
                                <div
                                    ref={provided.innerRef}
                                    style={getListStyle(snapshot.isDraggingOver)}>
                                    {(state.selected && state.selected.length > 0) && state.selected.map((item, index) => (
                                        <Draggable
                                            key={item.id}
                                            draggableId={item.id}
                                            index={index}>
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style
                                                    )}>
                                                    {item.content}
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </Col>
                </Row>
            </DragDropContext>
        </div>
    );
};

const mapStateToProps = (state) => ({
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    widgetSaved: (state.dashboard && state.dashboard.widgetSaved) ? state.dashboard.widgetSaved : [],
});
const mapDispatchToProps = (dispatch) => ({
    saveDashboardWidget: (payload) => dispatch(DashboardAction.saveDashboardWidget(payload)),
    getDashboardWidget: (payload) => dispatch(DashboardAction.getDashboardWidget(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(WidgetSelector);